// Country Selector uses a src/js/components/tabs.js script for tabs handling
// It adds hash on tab change, that we want to remove when the tab modal is closed

import $ from 'jquery';

const elements = {
  closeBtn: document.querySelector('.js-country-selector-close'),
  countryItems: [...document.querySelectorAll('.js-country-selector-elements')],
};

function removeHash() {
  history.pushState('', document.title, window.location.pathname + window.location.search);
}

function init() {
  if (!elements.closeBtn) {
    return;
  }

  elements.closeBtn.addEventListener('click', removeHash);

  if (!elements.countryItems.length) {
    return;
  }

  // The old jQuery method that wraps every 14 tabpanel elements onto a column was moved here

  (function () {
    $('.js-country-selector-elements').each(function () {
      var a = $(this).children('.region-item');
      for (var i = 0; i < a.length; i += 14) {
        a.slice(i, i + 14).wrapAll('<div class="col-lg-4 country-items-columns"></div>');
      }
    });
  })();
}

export default init;
